import { FormHelperText } from '@mui/material'
import withStyles from './ErrorMessage.styled'

const ErrorMessage = withStyles(FormHelperText)

export default ErrorMessage
